import { render, staticRenderFns } from "./swift_M2.vue?vue&type=template&id=f5c1edd6&scoped=true&"
import script from "./swift_M2.vue?vue&type=script&lang=js&"
export * from "./swift_M2.vue?vue&type=script&lang=js&"
import style0 from "./swift_M2.vue?vue&type=style&index=0&id=f5c1edd6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c1edd6",
  null
  
)

export default component.exports